import { useMemo } from 'react';

import type { Property } from '../containers/App/types';

/**
 * Hook to determine if property has any specific affordable program.
 * Must have PropertyAffordablePrograms
 * @param {Property} property property object with propertyAffordableProgram array
 * @param {string} programName name of the affordable program to check
 * @returns boolean
 */
function usePropertyHasProgram(
  property: Property,
  programName: string,
): boolean {
  // Property might have the includes with either the full table include or the shorthand name
  // For both PropertyAffordableProgram and MasterAffordableProgram so we check both checks
  return useMemo(() => {
    const paps = property?.pap ?? property?.propertyAffordableProgram ?? [];
    return paps?.some((pap) =>
      (pap?.map ?? pap?.masterAffordableProgram ?? {})?.name?.includes(
        programName,
      ),
    );
  }, [property, programName]);
}

export default usePropertyHasProgram;
